import "antd/dist/antd.min.css";
import "antd-button-color/dist/css/style.css";

import axios from "axios";
import React, { useEffect, useState } from "react";

import swal from "sweetalert";

import {
  Row,
  Col,
  Form,
  Layout,
  Button,
  Descriptions,
  Table,
  Card,
  Divider,
  Tabs,
  Input,
  Space,
  BackTop,
  PageHeader,
  Spin,
  Select,
  Typography,
  Tag,
  Badge,
  InputNumber,
  Modal,
  Radio
} from "antd";

import { createGlobalStyle } from "styled-components";

import Header_title_c from "../controls/Header_title_c";
import Footer_last from "../controls/Footer_last";

import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";
import thTH from "antd/lib/locale/th_TH";
import dayjsGenerateConfig from "rc-picker/lib/generate/dayjs";
import generatePicker from "antd/es/date-picker/generatePicker";

import {
  SaveOutlined,
  ClearOutlined,
  PaperClipOutlined,
  EditOutlined,
  DeleteOutlined
} from "@ant-design/icons";

const { Content } = Layout;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const StyledForm = createGlobalStyle`.ant-form-item {
    margin-bottom: 5px;
  }
  `;

const layout1 = {
  labelCol: { span: 3 },
  wrapperCol: { span: 21 }
};

const layout2 = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 }
};

const layout3 = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 }
};

const Research_expenses_request = () => {
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const [form4] = Form.useForm();
  const [form5] = Form.useForm();

  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3002/api/";
  } else {
    xURL = "https://research.rihes.cmu.ac.th/api/";
  }
  const [xcmumis_id, _xcmumis_id] = useState("");
  const [xname, _xname] = useState("");
  const [xshortname, _xshortname] = useState("");
  const [xresearch, _xresearch] = useState("");
  const [xdate, _xdate] = useState("");

  const DatePicker = generatePicker(dayjsGenerateConfig);

  const [xAmout, _xAmout] = useState(0);
  const [xAmout2, _xAmout2] = useState(0);
  const [xAmout3, _xAmout3] = useState(0);
  const [xAmout4, _xAmout4] = useState(0);

  const [xSumAmount, _xSumAmount] = useState(0);
  const [xSumAmount2, _xSumAmount2] = useState(0);
  const [xSumAmount3, _xSumAmount3] = useState(0);
  const [xSumAmount4, _xSumAmount4] = useState(0);

  const [ListFile, _ListFile] = useState([]);
  const [ListFile2, _ListFile2] = useState([]);
  const [ListFile3, _ListFile3] = useState([]);
  const [ListFile4, _ListFile4] = useState([]);

  const xStatus = [
    { id: 1, name: "ยังไม่ได้จ่าย" },
    { id: 2, name: "จ่ายแล้วบางส่วน" },
    { id: 3, name: "จ่ายเงินครบแล้ว" }
  ];

  const [xStatusValue, _xStatusValue] = useState("1");
  const [xStatusValue2, _xStatusValue2] = useState("");

  const [dataExpenses, _dataExpenses] = useState();
  const [dataExpenses2, _dataExpenses2] = useState();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [isModalVisible3, setIsModalVisible3] = useState(false);

  const [oTitle, _oTitle] = useState("");
  const [oTitle2, _oTitle2] = useState("");

  const [HeadAdd, _HeadAdd] = useState("");
  const [HeadDate_a, _HeadDate_a] = useState("");
  const [Headexpense, _Headexpense] = useState("");

  const [xAmount1, _xAmount1] = useState(0);
  const [xAmount2, _xAmount2] = useState(0);
  const [xAmount3, _xAmount3] = useState(0);

  const [xAmount4, _xAmount4] = useState(0);
  const [xAmount5, _xAmount5] = useState(0);
  const [xAmount6, _xAmount6] = useState(0);

  const [requestID, _requestID] = useState("");

  const [value_ro, _value_ro] = useState();
  const [value_ro2, _value_ro2] = useState();

  const [xreference, _xreference] = useState();

  // const xtname = localStorage.getItem("tname");
  const xresearch2 = JSON.parse(localStorage.getItem("user"));
  const xtname = xresearch2.firstname_TH + " " + xresearch2.lastname_TH;

  useEffect(() => {
    // const token = localStorage.getItem("token");

    var url = new URL(window.location.href);

    const user = localStorage.getItem("user");

    if (!user) {
      // ถ้าไม่มี user ให้ redirect ไปหน้า login
      window.location = "/login";
    } else {
      getData(url.searchParams.get("cmumis_id"));
      getData2(url.searchParams.get("cmumis_id"));

      getAmount(url.searchParams.get("cmumis_id"));
    }

    // axios
    //   .post(
    //     xURL + "authen",
    //     {},
    //     {
    //       headers: {
    //         Authorization: `Basic ${token}`
    //       }
    //     }
    //   )
    //   .then(result => {
    //     if (result.data.status === "ok") {
    //       getData(url.searchParams.get("cmumis_id"));
    //       getData2(url.searchParams.get("cmumis_id"));

    //       getAmount(url.searchParams.get("cmumis_id"));
    //     } else {
    //       //alert("authen failed");
    //       localStorage.removeItem("token");
    //       window.location = "/";
    //     }
    //   })
    //   .catch(function(error) {
    //     // handle error
    //     console.log("problem here", error);
    //   });
  }, []);

  const getData = cmumis_id => {
    let xsdate = "",
      xedate = "";

    axios
      .post(xURL + "headpage", {
        cmumis_id: cmumis_id
      })
      .then(result => {
        xsdate = dayjs(result.data[0].start_date).format("DD/MM/BBBB");
        xedate = dayjs(result.data[0].end_date).format("DD/MM/BBBB");

        _xcmumis_id(result.data[0].cmumis_id);
        _xname(result.data[0].name_thai);
        _xshortname(result.data[0].short_name);
        _xresearch(result.data[0].research);
        _xdate(xsdate + " - " + xedate);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const getData2 = cmumis_id => {
    axios
      .post(xURL + "getExpenses", {
        cmumis_id: cmumis_id
      })
      .then(result => {
        const Tb1 = [];
        let xsum = 0,
          xsum2 = 0,
          xcal = 0,
          xsumcal = 0;

        let xdate_request = "",
          xdate_approved = "",
          xstatus = "",
          url_file = "",
          xposition = "";

        let xautonum = 0;

        result.data.forEach((i, idx) => {
          xautonum = xautonum + 1;

          xdate_request = dayjs(i.date_request).format("DD/MM/BBBB");

          if (i.date_approved) {
            xdate_approved = dayjs(i.date_approved).format("DD/MM/BBBB");
          } else {
            xdate_approved = "";
          }

          if (i.status == 1) {
            xstatus = "ยังไม่ได้จ่าย";
          } else if (i.status == 2) {
            xstatus = "จ่ายแล้วบางส่วน";
          } else if (i.status == 3) {
            xstatus = "จ่ายเงินครบแล้ว";
          }

          if (i.request_file) {
            url_file = `${xURL}file8/${i.request_file}`;
          } else {
            url_file = "";
          }

          xcal = i.request_amount - i.expenses;

          if (i.user_position == 1) {
            xposition = "คลินิก";
          } else if (i.user_position == 2) {
            xposition = "พัสดุ";
          } else if (i.user_position == 3) {
            xposition = "การเงิน";
          }

          Tb1.push({
            key: idx,
            num: parseInt(idx + 1),
            head_title: i.request_descripetion,
            date_request: xdate_request,
            date_approved: xdate_approved,
            amount: i.request_amount.toLocaleString(undefined, {
              minimumFractionDigits: 2
            }),
            amount2: i.expenses.toLocaleString(undefined, {
              minimumFractionDigits: 2
            }),
            linkfile: url_file,
            status: xstatus,
            file_name: i.request_file,
            request_id: i.request_id,
            // request_profin_id: i.request_profin_id,
            calamount: xcal.toLocaleString(undefined, {
              minimumFractionDigits: 2
            }),
            request_id: i.request_id,
            user_key: i.create_at,
            date_key: i.create_time,
            position: xposition,
            reference: i.request_profin_id
          });

          xsum = xsum + parseFloat(i.request_amount);
          xsum2 = xsum2 + parseFloat(i.expenses);
          xsumcal = xsumcal + parseFloat(xcal);
        });

        _xSumAmount(
          xsum.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xSumAmount2(
          xsum2.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _xSumAmount4(
          xsumcal.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _dataExpenses(Tb1);

        xautonum = parseInt(xautonum + 1);
        xautonum = String(xautonum).padStart(4, "0");

        _xreference(cmumis_id + "-" + xautonum);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const getAmount = cmumis_id => {
    axios
      .post(xURL + "Expenses_amount", {
        cmumis_id: cmumis_id
      })
      .then(result => {
        _xAmount1(
          result.data[0].money_receive.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xAmount2(
          (result.data[0].request_amount +
            result.data[0].transfer_fee +
            result.data[0].overhead_bath).toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xAmount3(
          (result.data[0].money_receive -
            (result.data[0].request_amount +
              result.data[0].transfer_fee +
              result.data[0].overhead_bath)).toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _xAmount4(
          result.data[0].transfer_fee.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xAmount5(
          result.data[0].overhead_bath.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
        _xAmount6(
          (result.data[0].request_amount +
            result.data[0].transfer_fee +
            result.data[0].overhead_bath).toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const bClearclick = () => {
    form2.resetFields();

    _xAmout(0);
    _ListFile([]);
    _xStatusValue("1");
    _value_ro();
  };

  const bClearclick2 = () => {
    form3.resetFields();

    _xAmout2(0);
    _ListFile2([]);
    _xStatusValue2("");
  };

  const bClearlistclick = () => {
    form4.resetFields();

    _xAmout3(0);
    _ListFile3([]);
  };

  const bClearlistclick2 = () => {
    form5.resetFields();

    _xAmout4(0);
    _ListFile4([]);
  };

  const bSaveclick = () => {
    const f = form2.getFieldValue();
    // if (!f.ip_request_profin_id) {
    //   swal("บันทึก ไม่ได้!", "ยังไม่ได้กรอก เลขที่ใบอนุมัติ", "warning");
    // } else
    // console.log(xAmout);
    if (!f.ip_request_description) {
      swal(
        "บันทึก ไม่ได้!",
        "ยังไม่ได้กรอก หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย",
        "warning"
      );
    } else if (!f.date_request) {
      swal("บันทึก ไม่ได้!", "ยังไม่ได้กรอก วันที่ขออนุมัติ", "warning");
    } else if (xAmout < 0 || xAmout == undefined) {
      swal("บันทึก ไม่ได้!", "ยังไม่ได้กรอก จำนวนเงินที่ขออนุมัติ", "warning");
    } else if (!xStatusValue) {
      // else if (ListFile == "" || typeof ListFile == "undefined") {
      //   swal("บันทึก ไม่ได้!", "ยังไม่ได้เพิ่ม ไฟล์อนุมัติ", "warning");
      // }
      swal("บันทึก ไม่ได้!", "ยังไม่ได้เลื่อก สถานะ", "warning");
    } else if (!value_ro) {
      swal("บันทึก ไม่ได้!", "ยังไม่ได้เลื่อก หน่วยงาน", "warning");
    } else {
      swal({
        title: "ยืนยัน เพิ่มรายการขออนุมัติใช้เงิน",
        text: "รหัส CMU MIS " + xcmumis_id,
        icon: "warning",
        buttons: ["ยกเลิก", "ยืนยัน"]
      }).then(willOk => {
        if (willOk) {
          insertData();
        }
      });
    }
  };

  const insertData = () => {
    const f = form2.getFieldValue();

    let xdate_request = "",
      xdate_approved = "";

    if (f.date_request) {
      xdate_request = dayjs(f.date_request).format("YYYY-MM-DD");
    }
    if (f.date_approved) {
      xdate_approved = dayjs(f.date_approved).format("YYYY-MM-DD");
    }

    // console.log(f.ip_request_description, xdate_request, xdate_approved);
    // console.log(xAmout, ListFile, xStatusValue);

    if (ListFile == "" || typeof ListFile == "undefined") {
      axios
        .post(xURL + "insert_exponses", {
          cmumis_id: xcmumis_id,
          title: f.ip_request_description,
          date_request: xdate_request,
          date_approved: xdate_approved,
          Amout: xAmout,
          stasus: xStatusValue,
          position: value_ro,
          username: xtname,
          reference: xreference,
          order: 1
          // request_profin_id: f.ip_request_profin_id
        })
        .then(result => {
          // console.log(result.data.length);
          swal({
            title: "แจ้งเตือน!",
            text: "บันทึก สำเร็จ",
            icon: "success",
            buttons: false,
            timer: 2000
          }).then(() => {
            bClearclick();
            getData2(xcmumis_id);
          });
        })
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    } else {
      const fd = new FormData();
      fd.append("file", ListFile);

      axios.post(xURL + "uploadfile8", fd).then(res => {
        axios
          .post(xURL + "insert_exponses", {
            cmumis_id: xcmumis_id,
            title: f.ip_request_description,
            date_request: xdate_request,
            date_approved: xdate_approved,
            Amout: xAmout,
            file_name: res.data.filename,
            stasus: xStatusValue,
            position: value_ro,
            username: xtname,
            reference: xreference,
            order: 2
            // request_profin_id: f.ip_request_profin_id
          })
          .then(result => {
            // console.log(result.data.length);
            swal({
              title: "แจ้งเตือน!",
              text: "บันทึก สำเร็จ",
              icon: "success",
              buttons: false,
              timer: 2000
            }).then(() => {
              bClearclick();
              getData2(xcmumis_id);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      });
    }
  };

  const bEditset = zdata => {
    setIsModalVisible(true);

    _xAmout2(Number(zdata.amount.replace(/,/g, "")));
    _oTitle(zdata.head_title);

    // let xvalue = 0;
    // if (zdata.position == "คลินิก") {
    //   _value_ro2(1);
    //   xvalue == 1;
    // } else if (zdata.position == "พัสดุ") {
    //   _value_ro2(2);
    //   xvalue == 2;
    // } else if (zdata.position == "การเงิน") {
    //   _value_ro2(3);
    //   xvalue == 3;
    // } else {
    //   xvalue == null;
    // }

    axios
      .post(xURL + "getDate_expenses", {
        cmumis_id: xcmumis_id,
        title: zdata.head_title
      })
      .then(result => {
        let xsdate = dayjs(result.data[0].date_request);

        let xedate = "";
        if (result.data[0].date_approved) {
          xedate = dayjs(result.data[0].date_approved);
        }

        // console.log("user_position:", zdata.user_position);

        form3.setFieldsValue({
          // ed_request_profin_id: zdata.request_profin_id,
          ed_request_description: zdata.head_title,
          edamount: Number(zdata.amount.replace(/,/g, "")),
          eddate_request: xsdate,
          eddate_approved: xedate,
          sl_status: zdata.status,
          ro_position: Number(result.data[0].user_position)
        });

        _value_ro2(Number(result.data[0].user_position));
        _xStatusValue2(result.data[0].status);
        _requestID(result.data[0].request_id);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const bEditclick = () => {
    const f = form3.getFieldValue();
    // if (!f.ed_request_profin_id) {
    //   swal("แก้ไข ไม่ได้!", "ยังไม่ได้กรอก เลขที่ใบอนุมัติ", "warning");
    // } else

    if (!f.ed_request_description) {
      swal(
        "แก้ไข ไม่ได้!",
        "ยังไม่ได้กรอก หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย",
        "warning"
      );
    } else if (!f.eddate_request) {
      swal("แก้ไข ไม่ได้!", "ยังไม่ได้กรอก วันที่ขออนุมัติ", "warning");
    } else if (xAmout2 < 0 || xAmout2 == undefined) {
      swal("แก้ไข ไม่ได้!", "ยังไม่ได้กรอก จำนวนเงินที่ขออนุมัติ", "warning");
    } else if (!xStatusValue2) {
      swal("แก้ไข ไม่ได้!", "ยังไม่ได้เลื่อก สถานะ", "warning");
    } else if (!value_ro2) {
      swal("บันทึก ไม่ได้!", "ยังไม่ได้เลื่อก หน่วยงาน", "warning");
    } else {
      swal({
        title: "ยืนยัน แก้ไขรายการขออนุมัติใช้เงิน",
        text: "รหัส CMU MIS " + xcmumis_id,
        icon: "warning",
        buttons: ["ยกเลิก", "ยืนยัน"]
      }).then(willOk => {
        if (willOk) {
          editData();
        }
      });
    }
  };

  const editData = () => {
    const f = form3.getFieldValue();
    // console.log(f.ed_request_description, f.eddate_request, f.eddate_approved);
    // console.log(xAmout2, xStatusValue2, ListFile2);
    // console.log(oTitle);

    let xdate_request = "",
      xdate_approved = "";

    if (f.eddate_request) {
      xdate_request = dayjs(f.eddate_request).format("YYYY-MM-DD");
    }
    if (f.eddate_approved) {
      xdate_approved = dayjs(f.eddate_approved).format("YYYY-MM-DD");
    }

    if (ListFile2 == "" || typeof ListFile2 == "undefined") {
      axios
        .post(xURL + "update_exponses", {
          cmumis_id: xcmumis_id,
          title: f.ed_request_description,
          date_request: xdate_request,
          date_approved: xdate_approved,
          Amout: xAmout2,
          stasus: xStatusValue2,
          oTitle: oTitle,
          username: xtname,
          order: 1,
          // request_profin_id: f.ed_request_profin_id,
          request_id: requestID,
          position: value_ro2
        })
        .then(result => {
          // console.log(result.data.length);
          swal({
            title: "แจ้งเตือน!",
            text: "แก้ไข สำเร็จ",
            icon: "success",
            buttons: false,
            timer: 2000
          }).then(() => {
            setIsModalVisible(false);
            window.location.reload();
          });
        })
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    } else {
      const fd = new FormData();
      fd.append("file", ListFile2);

      axios.post(xURL + "uploadfile8", fd).then(res => {
        axios
          .post(xURL + "update_exponses", {
            cmumis_id: xcmumis_id,
            title: f.ed_request_description,
            date_request: xdate_request,
            date_approved: xdate_approved,
            Amout: xAmout2,
            file_name: res.data.filename,
            stasus: xStatusValue2,
            oTitle: oTitle,
            username: xtname,
            order: 2,
            // request_profin_id: f.ed_request_profin_id,
            request_id: requestID,
            position: value_ro2
          })
          .then(result => {
            // console.log(result.data.length);
            swal({
              title: "แจ้งเตือน!",
              text: "แก้ไข สำเร็จ",
              icon: "success",
              buttons: false,
              timer: 2000
            }).then(() => {
              setIsModalVisible(false);
              window.location.reload();
            });
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      });
    }
  };

  const bAddset = zdata => {
    setIsModalVisible2(true);

    _HeadAdd(zdata.head_title);
    _HeadDate_a(zdata.date_approved);
    _Headexpense(zdata.amount);

    _requestID(zdata.request_id);
    getData3(zdata.request_id);
  };

  const getData3 = zdata => {
    // console.log(zdata);
    axios
      .post(xURL + "getExpenses_list", {
        request_id: zdata
      })
      .then(result => {
        const Tb1 = [];
        let xsum = 0;

        let xdate_approved = "",
          url_file = "";

        result.data.forEach((i, idx) => {
          xdate_approved = dayjs(i.date_approved).format("DD/MM/BBBB");

          if (i.file_expenses) {
            url_file = `${xURL}file8/${i.file_expenses}`;
          } else {
            url_file = "";
          }

          Tb1.push({
            key: idx,
            num: parseInt(idx + 1),
            expense_description: i.expense_description,
            date_approved: xdate_approved,
            amount: i.expenses.toLocaleString(undefined, {
              minimumFractionDigits: 2
            }),
            linkfile: url_file,
            remark: i.remark,
            file_name: i.file_expenses,
            user_key: i.create_at,
            date_key: i.create_time
          });

          xsum = xsum + parseFloat(i.expenses);
        });

        _xSumAmount3(
          xsum.toLocaleString(undefined, {
            minimumFractionDigits: 2
          })
        );

        _dataExpenses2(Tb1);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const bSavelistclick = () => {
    const f = form4.getFieldValue();

    if (!f.ip_expense_description) {
      swal("บันทึก ไม่ได้!", "ยังไม่ได้กรอก รายละเอียดค่าใช้จ่าย", "warning");
    } else if (!f.date_approved) {
      swal("บันทึก ไม่ได้!", "ยังไม่ได้กรอก วันที่จ่ายเงิน", "warning");
    } else if (!xAmout3) {
      swal("บันทึก ไม่ได้!", "ยังไม่ได้กรอก จำนวนเงินที่จ่ายจริง", "warning");
    } else {
      // else if (ListFile3 == "" || typeof ListFile3 == "undefined") {
      //   swal(
      //     "บันทึก ไม่ได้!",
      //     "ยังไม่ได้เพิ่ม ไฟล์หลักฐานการจ่ายเงิน",
      //     "warning"
      //   );
      // }
      swal({
        title: "ยืนยัน เพิ่มค่าใช้จ่าย",
        text: "เรื่อง " + HeadAdd,
        icon: "warning",
        buttons: ["ยกเลิก", "ยืนยัน"]
      }).then(willOk => {
        if (willOk) {
          insertDatalist();
        }
      });
    }
  };

  const insertDatalist = () => {
    const f = form4.getFieldValue();

    let xdate_approved = "";

    if (f.date_approved) {
      xdate_approved = dayjs(f.date_approved).format("YYYY-MM-DD");
    }

    // console.log(HeadAdd);
    // console.log(f.ip_expense_description, xdate_approved);
    // console.log(xAmout3, ListFile3, f.remark);

    if (ListFile3 == "" || typeof ListFile3 == "undefined") {
      axios
        .post(xURL + "insert_exponses_list", {
          request_descripetion: HeadAdd,
          title: f.ip_expense_description,
          date_approved: xdate_approved,
          Amout: xAmout3,
          remark: f.remark,
          request_id: requestID,
          username: xtname,
          order: 1
        })
        .then(result => {
          // console.log(result.data.length);
          swal({
            title: "แจ้งเตือน!",
            text: "บันทึก สำเร็จ",
            icon: "success",
            buttons: false,
            timer: 2000
          }).then(() => {
            bClearlistclick();
            getData3(requestID);
          });
        })
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    } else {
      const fd = new FormData();
      fd.append("file", ListFile3);

      axios.post(xURL + "uploadfile8", fd).then(res => {
        axios
          .post(xURL + "insert_exponses_list", {
            request_descripetion: HeadAdd,
            title: f.ip_expense_description,
            date_approved: xdate_approved,
            Amout: xAmout3,
            file_name: res.data.filename,
            remark: f.remark,
            request_id: requestID,
            username: xtname,
            order: 2
          })
          .then(result => {
            // console.log(result.data.length);
            swal({
              title: "แจ้งเตือน!",
              text: "บันทึก สำเร็จ",
              icon: "success",
              buttons: false,
              timer: 2000
            }).then(() => {
              bClearlistclick();
              getData3(requestID);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      });
    }
  };

  const bEditset2 = zdata => {
    setIsModalVisible3(true);

    _xAmout4(Number(zdata.amount.replace(/,/g, "")));
    _oTitle2(zdata.expense_description);

    axios
      .post(xURL + "getDate_expenseslist", {
        title: HeadAdd,
        title2: zdata.expense_description,
        request_id: requestID
      })
      .then(result => {
        let xsdate = dayjs(result.data[0].date_approved);

        form5.setFieldsValue({
          ed_expense_description: zdata.expense_description,
          eddate_approved: xsdate,
          edexpenses: Number(zdata.amount.replace(/,/g, "")),
          edremark: zdata.remark
        });
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const bEditlistclick = () => {
    const f = form5.getFieldValue();

    if (!f.ed_expense_description) {
      swal("แก้ไข ไม่ได้!", "ยังไม่ได้กรอก รายละเอียดค่าใช้จ่าย", "warning");
    } else if (!f.eddate_approved) {
      swal("แก้ไข ไม่ได้!", "ยังไม่ได้กรอก วันที่จ่ายเงิน", "warning");
    } else if (!xAmout4) {
      swal("แก้ไข ไม่ได้!", "ยังไม่ได้กรอก จำนวนเงินที่จ่ายจริง", "warning");
    } else {
      swal({
        title: "ยืนยัน แก้ไขค่าใช้จ่าย",
        text: "เรื่อง " + HeadAdd,
        icon: "warning",
        buttons: ["ยกเลิก", "ยืนยัน"]
      }).then(willOk => {
        if (willOk) {
          updateDatalist();
        }
      });
    }
  };

  const updateDatalist = () => {
    const f = form5.getFieldValue();

    let xdate_approved = "";

    if (f.eddate_approved) {
      xdate_approved = dayjs(f.eddate_approved).format("YYYY-MM-DD");
    }

    if (ListFile4 == "" || typeof ListFile4 == "undefined") {
      axios
        .post(xURL + "update_exponseslist", {
          title: HeadAdd,
          title2: f.ed_expense_description,
          date_approved: xdate_approved,
          Amout: xAmout4,
          remark: f.edremark,
          oTitle: oTitle2,
          order: 1,
          username: xtname,
          request_id: requestID
        })
        .then(result => {
          // console.log(result.data.length);
          swal({
            title: "แจ้งเตือน!",
            text: "แก้ไข สำเร็จ",
            icon: "success",
            buttons: false,
            timer: 2000
          }).then(() => {
            setIsModalVisible3(false);
            getData3(requestID);
          });
        })
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    } else {
      const fd = new FormData();
      fd.append("file", ListFile4);

      axios.post(xURL + "uploadfile8", fd).then(res => {
        axios
          .post(xURL + "update_exponseslist", {
            title: HeadAdd,
            title2: f.ed_expense_description,
            date_approved: xdate_approved,
            Amout: xAmout4,
            remark: f.edremark,
            oTitle: oTitle2,
            order: 2,
            username: xtname,
            file_name: res.data.filename,
            request_id: requestID
          })
          .then(result => {
            // console.log(result.data.length);
            swal({
              title: "แจ้งเตือน!",
              text: "แก้ไข สำเร็จ",
              icon: "success",
              buttons: false,
              timer: 2000
            }).then(() => {
              setIsModalVisible3(false);
              getData3(requestID);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      });
    }
  };

  const bDelete = zdata => {
    swal({
      title: "ยืนยัน รายการขออนุมัติใช้เงิน",
      text: "เรื่อง " + zdata.head_title,
      icon: "warning",
      buttons: ["ยกเลิก", "ยืนยัน"]
    }).then(willOk => {
      if (willOk) {
        deleteData(zdata);
      }
    });
  };

  const deleteData = zdata => {
    //ลบไฟล์รายละเอียดย่อย
    axios
      .post(xURL + "getExpenses_list", {
        request_id: zdata.request_id
      })
      .then(result => {
        result.data.forEach((i, idx) => {
          // console.log(i.file_expenses);
          if (i.file_expenses) {
            axios
              .post(xURL + "delete_file", {
                linkfile: i.file_expenses,
                order: 7
              })
              .then(result => {})
              .catch(function(error) {
                // handle error
                console.log("problem here", error);
              });
          }
        });
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    //ลบไฟล์หัวข้อหลัก

    if (zdata.tfile) {
      axios
        .post(xURL + "delete_file", {
          linkfile: zdata.file_name,
          order: 7
        })
        .then(result => {})
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    }

    axios
      .post(xURL + "delete_exponses", {
        title: zdata.head_title,
        request_id: zdata.request_id
      })
      .then(result => {
        swal({
          title: "แจ้งเตือน!",
          text: "ลบ สำเร็จ",
          icon: "success",
          buttons: false,
          timer: 2000
        }).then(() => {
          getData2(xcmumis_id);
        });
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const bDelete2 = zdata => {
    swal({
      title: "ยืนยัน ลบค่าใช้จ่าย",
      text: "รายละเอียดค่าใช้จ่าย " + zdata.expense_description,
      icon: "warning",
      buttons: ["ยกเลิก", "ยืนยัน"]
    }).then(willOk => {
      if (willOk) {
        deleteDatalist(zdata);
      }
    });
  };

  const deleteDatalist = zdata => {
    if (zdata.tfile) {
      axios
        .post(xURL + "delete_file", {
          linkfile: zdata.file_name,
          order: 7
        })
        .then(result => {})
        .catch(function(error) {
          // handle error
          console.log("problem here", error);
        });
    }

    axios
      .post(xURL + "delete_exponseslist", {
        title: HeadAdd,
        title2: zdata.expense_description,
        request_id: requestID
      })
      .then(result => {
        swal({
          title: "แจ้งเตือน!",
          text: "ลบ สำเร็จ",
          icon: "success",
          buttons: false,
          timer: 2000
        }).then(() => {
          getData3(requestID);
        });
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const cExpenses = [
    {
      title: "ที่",
      dataIndex: "num",
      key: "num",
      align: "center",
      width: 40
    },
    {
      title: "หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย",
      dataIndex: "head_title",
      key: "head_title",
      width: 400
    },
    {
      title: "วันที่ขออนุมัติ",
      dataIndex: "date_request",
      key: "date_request",
      align: "center",
      width: 120
    },
    // {
    //   title: "วันที่อนุมัติ",
    //   dataIndex: "date_approved",
    //   key: "date_approved",
    //   align: "center",
    //   width: 120
    // },
    {
      title: "จำนวนเงินที่ขออนุมัติ",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      width: 150,
      render: (text, record) => __TBShowText(record.amount, 1, 0)
    },
    // {
    //   title: "จำนวนค่าใช้จ่ายที่จ่ายแล้ว",
    //   dataIndex: "amount2",
    //   key: "amount2",
    //   align: "center",
    //   width: 170,
    //   render: (text, record) => __TBShowText(record.amount2, 1, 0)
    // },
    // {
    //   title: "คงเหลือ",
    //   dataIndex: "calamount",
    //   key: "calamount",
    //   align: "center",
    //   width: 120,
    //   render: (text, record) => __TBShowText(record.calamount, 1, 0)
    // },
    {
      title: "ไฟล์ขออนุมัติ",
      dataIndex: "tfile",
      key: "tfile",
      align: "center",
      width: 130,
      render(text, record, index) {
        return {
          children: record.linkfile
            ? <a
                href={record.linkfile}
                target="_blank"
                rel="noopener noreferrer"
              >
                <PaperClipOutlined /> ไฟล์อนุมัติ
              </a>
            : null
        };
      }
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      align: "center",
      width: 120
    },
    {
      title: "",
      dataIndex: "add",
      key: "add",
      align: "center",
      width: 100,
      render(text, record, index) {
        if (record.head_title !== "") {
          return {
            children: (
              <p
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "#000"
                }}
                onClick={e => {
                  //console.log("corresponding email is :", record.c4);
                  bAddset(record);
                }}
              >
                เพิ่มค่าใช้จ่าย
              </p>
            )
          };
        }
      }
    },
    {
      title: "แก้ไข",
      dataIndex: "edit",
      key: "edit",
      align: "center",
      width: 50,
      render(text, record, index) {
        if (record.head_title !== "") {
          return {
            children: (
              <Button
                ghost
                type="primary"
                icon={<EditOutlined />}
                size="small"
                onClick={e => {
                  //console.log("corresponding email is :", record.c4);
                  bEditset(record);
                }}
              />
            )
          };
        }
      }
    },
    {
      title: "ลบ",
      dataIndex: "delete",
      key: "delete",
      align: "center",
      width: 50,
      render(text, record, index) {
        if (record.head_title !== "") {
          return {
            children: (
              <Button
                danger
                icon={<DeleteOutlined />}
                size="small"
                onClick={e => {
                  //console.log("corresponding email is :", record.c4);
                  bDelete(record);
                }}
              />
            )
          };
        }
      }
    },
    {
      title: "หน่วยงาน",
      dataIndex: "position",
      key: "position",
      align: "center",
      width: 120
    },
    {
      title: "ผู้บันทึกข้อมูล",
      dataIndex: "user_key",
      key: "user_key",
      align: "center",
      width: 150
    },
    {
      title: "วัน-เวลา บันทึกข้อมูล",
      dataIndex: "date_key",
      key: "date_key",
      align: "center",
      width: 150
    },
    {
      title: "เลข Reference",
      dataIndex: "reference",
      key: "reference",
      align: "center",
      width: 150
    }
  ];

  const cExpenses2 = [
    {
      title: "ที่",
      dataIndex: "num",
      key: "num",
      align: "center",
      width: 40
    },
    {
      title: "รายละเอียดค่าใช้จ่าย",
      dataIndex: "expense_description",
      key: "expense_description",
      width: 430
    },
    {
      title: "วันที่จ่ายเงิน",
      dataIndex: "date_approved",
      key: "date_approved",
      align: "center",
      width: 120
    },
    {
      title: "จำนวนเงินที่จ่ายจริง",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      width: 150,
      render: (text, record) => __TBShowText(record.amount, 1, 0)
    },
    {
      title: "ไฟล์หลักฐานการจ่ายเงิน",
      dataIndex: "tfile",
      key: "tfile",
      align: "center",
      width: 160,
      render(text, record, index) {
        return {
          children: record.linkfile
            ? <a
                href={record.linkfile}
                target="_blank"
                rel="noopener noreferrer"
              >
                <PaperClipOutlined /> ไฟล์แนบ
              </a>
            : null
        };
      }
    },
    {
      title: "หมายเหตุ",
      dataIndex: "remark",
      key: "remark",
      width: 200
    },
    {
      title: "แก้ไข",
      dataIndex: "edit",
      key: "edit",
      align: "center",
      width: 50,
      render(text, record, index) {
        if (record.head_title !== "") {
          return {
            children: (
              <Button
                ghost
                type="primary"
                icon={<EditOutlined />}
                size="small"
                onClick={e => {
                  //console.log("corresponding email is :", record.c4);
                  bEditset2(record);
                }}
              />
            )
          };
        }
      }
    },
    {
      title: "ลบ",
      dataIndex: "delete",
      key: "delete",
      align: "center",
      width: 50,
      render(text, record, index) {
        if (record.head_title !== "") {
          return {
            children: (
              <Button
                danger
                icon={<DeleteOutlined />}
                size="small"
                onClick={e => {
                  //console.log("corresponding email is :", record.c4);
                  bDelete2(record);
                }}
              />
            )
          };
        }
      }
    },
    {
      title: "ผู้บันทึกข้อมูล",
      dataIndex: "user_key",
      key: "user_key",
      align: "center",
      width: 150
    },
    {
      title: "วัน-เวลา บันทึกข้อมูล",
      dataIndex: "date_key",
      key: "date_key",
      align: "center",
      width: 150
    }
  ];

  const onChangeededamount = e => {
    if (e == null) {
      _xAmout();
    } else {
      _xAmout(e);
    }
  };

  const onChangeededamount2 = e => {
    if (e == null) {
      _xAmout2();
    } else {
      _xAmout2(e);
    }
  };

  const onChangeededamount3 = e => {
    if (e == null) {
      _xAmout3();
    } else {
      _xAmout3(e);
    }
  };

  const onChangeededamount4 = e => {
    if (e == null) {
      _xAmout4();
    } else {
      _xAmout4(e);
    }
  };

  const onChangeU = e => {
    //console.log(e, e.target.files[0]);

    _ListFile(e.target.files[0]);
  };

  const onChangeU2 = e => {
    //console.log(e, e.target.files[0]);

    _ListFile2(e.target.files[0]);
  };

  const onChangeU3 = e => {
    //console.log(e, e.target.files[0]);

    _ListFile3(e.target.files[0]);
  };

  const onChangeU4 = e => {
    //console.log(e, e.target.files[0]);

    _ListFile4(e.target.files[0]);
  };

  function handleChange1(value) {
    //console.log(`selected ${value}`);
    // _xReceiptValue(value);
    _xStatusValue(value);
  }

  function handleChange2(value) {
    //console.log(`selected ${value}`);
    // _xReceiptValue(value);
    _xStatusValue2(value);
  }

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk2 = () => {
    setIsModalVisible2(false);

    window.location.reload();
  };

  const handleCancel2 = () => {
    setIsModalVisible2(false);

    window.location.reload();
  };

  const handleOk3 = () => {
    setIsModalVisible3(false);
  };

  const handleCancel3 = () => {
    setIsModalVisible3(false);
  };

  const onChange_ro = e => {
    // console.log("radio checked", e.target.value);
    _value_ro(e.target.value);
  };

  const onChange_ro2 = e => {
    // console.log("radio checked", e.target.value);
    _value_ro2(e.target.value);
  };

  //formatttable (Rigth or Left)
  function __TBShowText(zData, zRigth, zLeft) {
    if (zRigth === 1 && zLeft === 0) {
      return (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text>
            {zData}
          </Text>
        </div>
      );
    } else if (zRigth === 0 && zLeft === 1) {
      return (
        <div style={{ display: "flex" }}>
          <Text>
            {zData}
          </Text>
        </div>
      );
    }
  }

  return (
    <React.Fragment>
      <StyledForm />

      <Header_title_c
        tname={JSON.parse(localStorage.getItem("user"))}
        // tname={localStorage.getItem("tname")}
        // research_id={localStorage.getItem("research_id")}
      />

      <Content
        className="site-layout"
        style={{ padding: "0 20px", marginTop: 64 }}
      >
        <Row justify="center">
          <Col span={23}>
            <PageHeader
              className="site-page-header"
              title={
                <a
                  style={{
                    color: "black"
                  }}
                  onClick={() => {
                    window.close();
                  }}
                >
                  เพิ่มรายการขออนุมัติใช้เงิน
                </a>
              }
              onBack={() => window.close()}
            />

            <Divider />

            <Card title="">
              <Form form={form1} {...layout1}>
                <Form.Item
                  label={
                    <Text style={{ fontWeight: "bold" }}>รหัส CMU MIS</Text>
                  }
                >
                  {xcmumis_id}
                </Form.Item>

                <Form.Item
                  label={
                    <Text style={{ fontWeight: "bold" }}>ชื่อโครงการ</Text>
                  }
                >
                  {xname}
                </Form.Item>

                <Form.Item
                  label={
                    <Text style={{ fontWeight: "bold" }}>ชื่อย่อโครงการ</Text>
                  }
                >
                  <p
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      marginBottom: "5px"
                    }}
                  >
                    {xshortname}
                  </p>
                </Form.Item>

                <Form.Item
                  label={
                    <Text style={{ fontWeight: "bold" }}>หัวหน้าโครงการ</Text>
                  }
                >
                  {xresearch}
                </Form.Item>

                <Form.Item
                  label={<Text style={{ fontWeight: "bold" }}>ระยะเวลา</Text>}
                >
                  {xdate}
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>

        <br />

        <Row justify="center">
          <Col span={23}>
            <Card title="รายการขออนุมัติใช้เงิน">
              <Form
                form={form2}
                initialValues={{
                  // ip_request_profin_id: "",
                  ip_request_description: ""
                }}
                {...layout2}
              >
                {/* เอา เลขที่ใบอนุมัติ ออก 30/07/2025 */}
                {/* <Form.Item
                  label="เลขที่ใบอนุมัติ"
                  name="ip_request_profin_id"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอก เลขที่ใบอนุมัติ"
                    }
                  ]}
                >
                  <Input
                    autoFocus
                    allowClear
                    placeholder="เลขที่ใบอนุมัติ"
                    style={{ width: 250 }}
                  />
                </Form.Item> */}

                <Form.Item label="เลข Reference" name="ip_reference">
                  <Row>
                    <Input
                      allowClear
                      style={{ width: 250 }}
                      readOnly
                      value={xreference}
                    />
                  </Row>
                </Form.Item>

                <Form.Item
                  label="หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย"
                  name="ip_request_description"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอก หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย"
                    }
                  ]}
                >
                  <Input
                    autoFocus
                    allowClear
                    placeholder="หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย"
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  label="วันที่ขออนุมัติ"
                  name="date_request"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอก วันที่ขออนุมัติ"
                    }
                  ]}
                >
                  <DatePicker format="DD/MM/BBBB" />
                </Form.Item>

                <Form.Item label="วันที่อนุมัติ" name="date_approved">
                  <DatePicker format="DD/MM/BBBB" />
                </Form.Item>

                <Form.Item
                  label="จำนวนเงินที่ขออนุมัติ"
                  name="edamount"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอก จำนวนเงินที่ขออนุมัติ"
                    }
                  ]}
                >
                  <InputNumber
                    style={{ width: 250 }}
                    //disabled={Export}
                    min="-9999999999"
                    max="9999999999"
                    maxLength="12"
                    onChange={e => onChangeededamount(e)}
                    formatter={value =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  />
                </Form.Item>

                <Form.Item label="ไฟล์ขออนุมัติ" name="edfile">
                  <Input
                    className="form-control"
                    id="drop-area"
                    type="file"
                    onChange={e => onChangeU(e)}
                  />
                </Form.Item>

                <Form.Item label="สถานะ" name="sl_status">
                  <Select
                    style={{ width: 400, color: "black" }}
                    onChange={handleChange1}
                    disabled
                    defaultValue="ยังไม่ได้จ่าย"
                  >
                    {xStatus.map((i, idx) => {
                      return (
                        <Option value={i.id}>
                          {i.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="หน่วยงาน"
                  name="ro_position"
                  style={{ marginTop: "15px" }}
                  rules={[
                    {
                      required: true,
                      message: "กรุณาเลือก หน่วยงาน"
                    }
                  ]}
                >
                  <Radio.Group onChange={onChange_ro} value={value_ro}>
                    <Radio value={1}>คลินิก</Radio>
                    <Radio value={2}>พัสดุ</Radio>
                    <Radio value={3}>การเงิน</Radio>
                  </Radio.Group>
                </Form.Item>
              </Form>

              <br />

              <Row justify="center">
                <Space>
                  <Button ghost type="primary" onClick={bSaveclick}>
                    <SaveOutlined /> บันทึก
                  </Button>

                  <Button ghost type="danger" onClick={bClearclick}>
                    <ClearOutlined /> เคลียร์
                  </Button>
                </Space>
              </Row>

              <br />

              <Form {...layout2}>
                <b>
                  <Form.Item label="เงินรับทั้งหมด" name="txtamount1">
                    {xAmount1} บาท
                  </Form.Item>
                  <Form.Item label="หักค่าใช้จ่าย" name="txtamount2">
                    {xAmount2} บาท
                  </Form.Item>
                  <Form.Item label="ยอดเงินคงเหลือ" name="txtamount3">
                    {xAmount3} บาท
                  </Form.Item>
                </b>
              </Form>
            </Card>

            <br />

            <Table
              bordered
              scroll={{ x: "max-content" }}
              dataSource={dataExpenses}
              columns={cExpenses}
              size="small"
              pagination={false}
              summary={() =>
                <Table.Summary fixed>
                  <Table.Summary.Row
                    style={{
                      textAlign: "right",
                      backgroundColor: "#b5f5ec"
                    }}
                  >
                    <Table.Summary.Cell />
                    <Table.Summary.Cell />
                    <Table.Summary.Cell />
                    <Table.Summary.Cell>รวม</Table.Summary.Cell>
                    <Table.Summary.Cell>
                      {xSumAmount.toLocaleString()}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      {xSumAmount2.toLocaleString()}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      {xSumAmount4.toLocaleString()}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell />
                    <Table.Summary.Cell />
                    <Table.Summary.Cell />
                    <Table.Summary.Cell />
                    <Table.Summary.Cell />
                    <Table.Summary.Cell />
                    {/* <Table.Summary.Cell />
                    <Table.Summary.Cell /> */}
                  </Table.Summary.Row>
                </Table.Summary>}
            />
            <p
              style={{
                fontWeight: "bold",
                fontSize: "12px",
                marginTop: "5px"
              }}
            >
              - หมายเหตุ:
              รายการอนุมัติค่าใช้จ่ายสามารถใส่ค่าใช้จ่ายได้หลายรายการ{" "}
            </p>

            <br />
            <Form {...layout3}>
              <b>
                <Form.Item
                  label="ค่าธรรมเนียมธนาคารรับโอนเงิน ของโครงการนี้"
                  name="txtamount4"
                >
                  {xAmount4} บาท
                </Form.Item>
                <Form.Item
                  label="ค่าบริหารโครงการ ของโครงการนี้"
                  name="txtamount5"
                >
                  {xAmount5} บาท
                </Form.Item>
                <Form.Item label="รวมค่าใช้จ่ายทั้งหมด" name="txtamount6">
                  {xAmount6} บาท
                </Form.Item>
              </b>
            </Form>
          </Col>
        </Row>
      </Content>

      <Modal
        title={
          <Text style={{ fontWeight: "bold" }}>
            แก้ไขรายการขออนุมัติใช้เงิน
          </Text>
        }
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={1200}
      >
        <Form
          form={form3}
          initialValues={{
            ed_request_description: ""
            // ed_request_profin_id: ""
          }}
          {...layout2}
        >
          {/* เอา เลขที่ใบอนุมัติ ออก 30/07/2025 */}
          {/* <Form.Item
            label="เลขที่ใบอนุมัติ"
            name="ed_request_profin_id"
            rules={[
              {
                required: true,
                message: "กรุณากรอก เลขที่ใบอนุมัติ"
              }
            ]}
          >
            <Input
              autoFocus
              allowClear
              placeholder="เลขที่ใบอนุมัติ"
              style={{ width: 250 }}
            />
          </Form.Item> */}

          <Form.Item
            label="หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย"
            name="ed_request_description"
            rules={[
              {
                required: true,
                message: "กรุณากรอก หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย"
              }
            ]}
          >
            <Input
              allowClear
              placeholder="หัวข้อเรื่องที่ขออนุมัติค่าใช้จ่าย"
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            label="วันที่ขออนุมัติ"
            name="eddate_request"
            rules={[
              {
                required: true,
                message: "กรุณากรอก วันที่ขออนุมัติ"
              }
            ]}
          >
            <DatePicker format="DD/MM/BBBB" />
          </Form.Item>

          <Form.Item label="วันที่อนุมัติ" name="eddate_approved">
            <DatePicker format="DD/MM/BBBB" />
          </Form.Item>

          <Form.Item
            label="จำนวนเงินที่ขออนุมัติ"
            name="edamount"
            rules={[
              {
                required: true,
                message: "กรุณากรอก จำนวนเงินที่ขออนุมัติ"
              }
            ]}
          >
            <InputNumber
              style={{ width: 250 }}
              //disabled={Export}
              min="-9999999999"
              max="9999999999"
              maxLength="12"
              onChange={e => onChangeededamount2(e)}
              formatter={value =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={value => value.replace(/\$\s?|(,*)/g, "")}
            />
          </Form.Item>

          <Form.Item label="ไฟล์ขออนุมัติ" name="edfile">
            <Input
              className="form-control"
              id="drop-area"
              type="file"
              onChange={e => onChangeU2(e)}
            />
            <p
              style={{
                fontWeight: "bold",
                fontSize: "12px",
                marginTop: "3px",
                color: "red"
              }}
            >
              * หากไม่ต้องการเปลี่ยนไฟล์ ให้แก้ไขได้เลย ไม่ต้องเลือกไฟล์ใหม่
            </p>
          </Form.Item>

          <Form.Item label="สถานะ" name="sl_status">
            <Select style={{ width: 400 }} onChange={handleChange2}>
              {xStatus.map((i, idx) => {
                return (
                  <Option value={i.id}>
                    {i.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="หน่วยงาน"
            name="ro_position"
            style={{ marginTop: "15px" }}
            rules={[
              {
                required: true,
                message: "กรุณาเลือก หน่วยงาน"
              }
            ]}
          >
            <Radio.Group onChange={onChange_ro2} value={value_ro2}>
              <Radio value={1}>คลินิก</Radio>
              <Radio value={2}>พัสดุ</Radio>
              <Radio value={3}>การเงิน</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>

        <br />

        <Row justify="center">
          <Space>
            <Button ghost type="primary" onClick={bEditclick}>
              <SaveOutlined /> แก้ไข
            </Button>

            <Button ghost type="danger" onClick={bClearclick2}>
              <EditOutlined /> เคลียร์
            </Button>
          </Space>
        </Row>
      </Modal>

      <Modal
        title={<Text style={{ fontWeight: "bold" }}>เพิ่มค่าใช้จ่าย</Text>}
        visible={isModalVisible2}
        onOk={handleOk2}
        onCancel={handleCancel2}
        footer={null}
        width={1600}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <div style={{ display: "flex", fontWeight: "bold" }}>
            <span style={{ width: "170px" }}>เรื่อง</span>
            <span>
              : {HeadAdd}
            </span>
          </div>
          <div style={{ display: "flex", fontWeight: "bold" }}>
            <span style={{ width: "170px" }}>วันที่ได้รับอนุมัติ</span>
            <span>
              : {HeadDate_a}
            </span>
          </div>
          <div style={{ display: "flex", fontWeight: "bold" }}>
            <span style={{ width: "170px" }}>ค่าใช้จ่ายที่ขออนุมัติ</span>
            <span>
              : {Headexpense}
            </span>
            <span style={{ marginLeft: "15px" }}>บาท</span>
          </div>
        </div>

        <Divider />
        <Form
          form={form4}
          initialValues={{
            ip_request_description: ""
          }}
          {...layout2}
        >
          <Form.Item
            label="รายละเอียดค่าใช้จ่าย"
            name="ip_expense_description"
            rules={[
              {
                required: true,
                message: "กรุณากรอก รายละเอียดค่าใช้จ่าย"
              }
            ]}
          >
            <Input
              autoFocus
              allowClear
              placeholder="รายละเอียดค่าใช้จ่าย"
              style={{ width: "90%" }}
            />
          </Form.Item>

          <Form.Item
            label="วันที่จ่ายเงิน"
            name="date_approved"
            rules={[
              {
                required: true,
                message: "กรุณากรอก วันที่จ่ายเงิน"
              }
            ]}
          >
            <DatePicker format="DD/MM/BBBB" />
          </Form.Item>

          <Form.Item
            label="จำนวนเงินที่จ่ายจริง"
            name="edexpenses"
            rules={[
              {
                required: true,
                message: "กรุณากรอก จำนวนเงินที่จ่ายจริง"
              }
            ]}
          >
            <InputNumber
              style={{ width: 250 }}
              //disabled={Export}
              min="-9999999999"
              max="9999999999"
              maxLength="12"
              onChange={e => onChangeededamount3(e)}
              formatter={value =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={value => value.replace(/\$\s?|(,*)/g, "")}
            />
          </Form.Item>

          <Form.Item label="ไฟล์หลักฐานการจ่ายเงิน" name="edfile">
            <Input
              className="form-control"
              id="drop-area"
              type="file"
              onChange={e => onChangeU3(e)}
            />
          </Form.Item>

          <Form.Item label="หมายเหตุ" name="remark">
            <TextArea
              rows={2}
              allowClear
              placeholder="หมายเหตุ"
              style={{ width: "90%" }}
            />
          </Form.Item>
        </Form>

        <br />

        <Row justify="center">
          <Space>
            <Button ghost type="primary" onClick={bSavelistclick}>
              <SaveOutlined /> บันทึก
            </Button>

            <Button ghost type="danger" onClick={bClearlistclick}>
              <ClearOutlined /> เคลียร์
            </Button>
          </Space>
        </Row>

        <Divider />

        <Table
          bordered
          scroll={{ x: "max-content" }}
          dataSource={dataExpenses2}
          columns={cExpenses2}
          size="small"
          pagination={false}
          summary={() =>
            <Table.Summary fixed>
              <Table.Summary.Row
                style={{
                  textAlign: "right",
                  backgroundColor: "#b5f5ec"
                }}
              >
                <Table.Summary.Cell />
                <Table.Summary.Cell />
                <Table.Summary.Cell>รวม</Table.Summary.Cell>
                <Table.Summary.Cell>
                  {xSumAmount3.toLocaleString()}
                </Table.Summary.Cell>
                <Table.Summary.Cell />
                <Table.Summary.Cell />
                <Table.Summary.Cell />
                <Table.Summary.Cell />
                <Table.Summary.Cell />
                <Table.Summary.Cell />
              </Table.Summary.Row>
            </Table.Summary>}
        />
        <div style={{ height: "20px" }} />
      </Modal>

      <Modal
        title={<Text style={{ fontWeight: "bold" }}>แก้ไขค่าใช้จ่าย</Text>}
        visible={isModalVisible3}
        onOk={handleOk3}
        onCancel={handleCancel3}
        footer={null}
        width={1000}
      >
        <Form
          form={form5}
          initialValues={{
            ip_request_description: ""
          }}
          {...layout2}
        >
          <Form.Item
            label="รายละเอียดค่าใช้จ่าย"
            name="ed_expense_description"
            rules={[
              {
                required: true,
                message: "กรุณากรอก รายละเอียดค่าใช้จ่าย"
              }
            ]}
          >
            <Input
              autoFocus
              allowClear
              placeholder="รายละเอียดค่าใช้จ่าย"
              style={{ width: "90%" }}
            />
          </Form.Item>

          <Form.Item
            label="วันที่จ่ายเงิน"
            name="eddate_approved"
            rules={[
              {
                required: true,
                message: "กรุณากรอก วันที่จ่ายเงิน"
              }
            ]}
          >
            <DatePicker format="DD/MM/BBBB" />
          </Form.Item>

          <Form.Item
            label="จำนวนเงินที่จ่ายจริง"
            name="edexpenses"
            rules={[
              {
                required: true,
                message: "กรุณากรอก จำนวนเงินที่จ่ายจริง"
              }
            ]}
          >
            <InputNumber
              style={{ width: 250 }}
              //disabled={Export}
              min="-9999999999"
              max="9999999999"
              maxLength="12"
              onChange={e => onChangeededamount4(e)}
              formatter={value =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={value => value.replace(/\$\s?|(,*)/g, "")}
            />
          </Form.Item>

          <Form.Item label="ไฟล์หลักฐานการจ่ายเงิน" name="edfile">
            <Input
              className="form-control"
              id="drop-area"
              type="file"
              onChange={e => onChangeU4(e)}
            />
            <p
              style={{
                fontWeight: "bold",
                fontSize: "12px",
                marginTop: "3px",
                color: "red"
              }}
            >
              * หากไม่ต้องการเปลี่ยนไฟล์ ให้แก้ไขได้เลย ไม่ต้องเลือกไฟล์ใหม่
            </p>
          </Form.Item>

          <Form.Item label="หมายเหตุ" name="edremark">
            <TextArea
              rows={2}
              allowClear
              placeholder="หมายเหตุ"
              style={{ width: "90%" }}
            />
          </Form.Item>
        </Form>

        <br />

        <Row justify="center">
          <Space>
            <Button ghost type="primary" onClick={bEditlistclick}>
              <SaveOutlined /> แก้ไข
            </Button>

            <Button ghost type="danger" onClick={bClearlistclick2}>
              <EditOutlined /> เคลียร์
            </Button>
          </Space>
        </Row>
      </Modal>

      <div style={{ height: "100px" }} />

      <Footer_last />
      <BackTop />
    </React.Fragment>
  );
};

export default Research_expenses_request;
